// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2ALLZ","header":"MessagesList_header__2LMAK","chat":"MessagesList_chat__bb7bF"};